export enum TicketCategory {
  BUG = 'bug',
  ACCESS = 'access',
  INFRASTRUCTURE = 'infrastructure',
  FEATURE = 'feature',
  OTHER = 'other'
}
